var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.beginClientX = 0;
        _this.mouseMoveStata = false;
        _this.maxwidth = 0;
        _this.confirmWords = '拖动滑块验证';
        _this.confirmSuccess = false;
        return _this;
    }
    default_1.prototype.mousedownFn = function (e) {
        if (!this.confirmSuccess) {
            e.preventDefault && e.preventDefault();
            this.mouseMoveStata = true;
            this.beginClientX = e.clientX;
        }
    };
    default_1.prototype.successFunction = function () {
        this.confirmSuccess = true;
        this.confirmWords = '验证通过';
        if (window.addEventListener) {
            document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn);
            document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn);
        }
        else {
            document.getElementsByTagName('html')[0].removeEventListener('mouseup', function () { });
        }
        document.getElementsByClassName('drag_text')[0].style.color = '#fff';
        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
        this.$emit('success', true);
    };
    default_1.prototype.mouseMoveFn = function (e) {
        if (this.mouseMoveStata) {
            var width = e.clientX - this.beginClientX;
            if (width > 0 && width <= this.maxwidth) {
                document.getElementsByClassName('handler')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
            }
            else if (width > this.maxwidth) {
                this.successFunction();
            }
        }
    };
    default_1.prototype.moseUpFn = function (e) {
        this.mouseMoveStata = false;
        var width = e.clientX - this.beginClientX;
        if (width < this.maxwidth) {
            document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
    };
    default_1.prototype.mounted = function () {
        this.$emit('show');
        this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
        document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn);
        document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn);
    };
    default_1 = __decorate([
        Component({})
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/common/ValidateCode.vue
// module id = IBMU
// module chunks = 0 1 2 3